import { ELEMENT_TYPES } from 'components/RichTextEditorField/constants';
import { Note, NoteReactions, NoteTag } from 'models/Note';
import { ReactionType } from 'models/Reactions';
import credentialsService from 'services/credentialsService';
import { getIsCurrentUser, safeParse } from 'utils';

export const BOSS_MODE_TAG = 'Resolve';

export const parseObjectToGetTag = (nodes: any[]): NoteTag[] => {
  const tags: NoteTag[] = [];

  nodes.forEach((node) => {
    if (!node || !Array.isArray(node.children)) return;

    const { id, type, character, children } = node || {};

    if (id && character && type === ELEMENT_TYPES.MENTION) {
      tags.push(
        id === BOSS_MODE_TAG
          ? { isBossMode: true }
          : {
              userId: id,
              username: character,
              isBossMode: false,
            },
      );
    }

    tags.push(...parseObjectToGetTag(children));
  });

  return tags;
};

export const extractTagsFromText = (text: string) => {
  const parsedText = safeParse(text);

  if (!parsedText || !Array.isArray(parsedText)) return [];

  return parseObjectToGetTag(parsedText);
};

export const updateNoteReaction = (
  notes: Note[],
  noteId: string,
  reaction: ReactionType,
) =>
  notes.map((note) => {
    if (!note || note._id !== noteId) return note;

    const { reactions } = note;

    const hasReactionAlready = reactions?.[reaction]?.some(({ userId }) =>
      getIsCurrentUser(userId),
    );

    const cleanReactions = Object.entries(reactions || {}).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: value?.filter(({ userId }) => !getIsCurrentUser(userId)),
      }),
      {} as NoteReactions,
    );

    const nextReactions = hasReactionAlready
      ? cleanReactions
      : {
          ...cleanReactions,
          [reaction]: [
            ...(cleanReactions?.[reaction] || []),
            { userId: credentialsService.currentUserId, reactedAt: new Date() },
          ],
        };

    return {
      ...note,
      reactions: nextReactions,
    };
  });
